<template>
    <div class="input-container">
        <label class="label-l content-2">{{ label }}</label>
        <div :class="['input-group', { disabled: this.disabled }]">
            <input :type="this.isPasswordVisible && this.inputType === 'password' ? 'text' : this.inputType"
                class="text-field label-xl" :class="{'error': this.error}" :placeholder="this.placeholder" v-model="syncValue" :disabled="this.disabled" />
            <span class="icon" v-if="this.inputType === 'password'" @click="togglePasswordVisibility">
                <span v-if="showIcon" class="icon" v-html="icon"></span>
            </span>
        </div>
        <p v-if="this.showHelperText" :class="['helper-text label-l', { error: this.error }]">{{ this.helperText }}</p>
    </div>
</template>

<style scoped>
.input-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.input-group {
    display: flex;
    gap: 16px;
    align-items: center;
    border-radius: var(--border-radius-m);
    border: 1px solid var(--border-1);
    background: var(--background-2);
    padding: 8px 16px;
    width: 100%;
    height: 48px;
}

.input-group:hover {
    border: 1px solid var(--semantic-highlight-hover);
}

.input-group.disabled {
    border: 1px solid var(--border-disable);
    background: var(--background-disable);
    cursor: none;
    pointer-events: none;
}

.icon {
    cursor: pointer;
}

.text-field {
    width: 100%;
    color: var(--content-1);
    caret-color: var(--border-focus);
    text-decoration: none;
    background: none;
    border: none;
    outline: none;
    appearance: textfield;
    -moz-appearance: textfield;
}

.text-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.text-field::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.text-field:focus {
    color: var(--content-1);
}

.text-field.error {
    color: var(--semantic-danger);
}

.helper-text {
    color: var(--content-2);
}

.helper-text.error {
    color: var(--semantic-danger);
}
</style>

<script>
export default {
    name: 'InputTextFieldComponent',
    props: {
        label: {
            type: String,
            default: 'Label',
        },
        placeholder: {
            type: String,
            default: 'Placeholder',
        },
        value: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
        helperText: {
            type: String,
            default: '',
        },
        showHelperText: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        inputType: {
            type: String,
            default: 'text',
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isPasswordVisible: false,
        };
    },
    computed: {
        syncValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("update:value", newValue);
            }
        }
    },
    methods: {
        togglePasswordVisibility() {
            this.isPasswordVisible = !this.isPasswordVisible;
        },
    },
};
</script>